import { Controller } from "stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['container', 'row', 'details']

  connect () {
    this.loadAttachedFileFromParams()
  }

  loadFileDetails(e) {
    let fileId = e.currentTarget.parentElement.dataset.id;
    this.renderAttachedFile(fileId);
  }

  loadAttachedFileFromParams() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const attachedFileId = urlParams.get('attached_file_id')
    if (attachedFileId !== null) {
      this.renderAttachedFile(attachedFileId);
    }
  }

  renderAttachedFile(fileId) {
    let loadPath = `/admin/attached_files/${fileId}/load_details`
    Rails.ajax({
      type: "post",
      dataType: 'json',
      url: loadPath,
      success: (data) => this.containerTarget.innerHTML += data.html,
      error: function(data) { alert('Error: no Deal File match this ID') }
    })
  }

  remove() {
    this.detailsTarget.outerHTML = ''
  }
}